function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWorld = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 1.874,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.149,37.923L16.149,34.492L16.149,10.41L28.149,13.842L28.149,37.923ZM30.149,37.848L30.149,13.692L38.093,10.51C39.08,10.117 40.149,10.842 40.149,11.904L40.149,32.829C40.149,33.442 39.774,33.992 39.205,34.223L30.149,37.842L30.149,37.848ZM5.093,14.11L14.149,10.492L14.149,34.642L6.205,37.823C5.218,38.217 4.149,37.492 4.149,36.429L4.149,15.504C4.149,14.892 4.524,14.342 5.093,14.11Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWorld);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/world.7ec1fe143ce369496c0d28fa46d8d09d.svg";